import BaseRouter from 'scoreboard/components/base-router'
import BookmarksNav from './bookmarks-nav'
import appDisplay from 'scoreboard/components/app-display'
import Bookmark from 'scoreboard/bookmarks/bookmark'
import BookmarksEdit from 'scoreboard/bookmarks/bookmarks-edit'
import BookmarksFolderForm from 'scoreboard/bookmarks/bookmarks-folder-form'
import BookmarksOverview from './bookmarks-overview'
import BookmarksFolderOverview from './bookmarks-folder-overview'
import ViewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import globals from 'scoreboard/components/globals'
import _ from 'lodash'
import spectator from 'scoreboard/components/spectator'

/**
 * @extends BaseRouter
 */
var BookmarksRouter = BaseRouter.extend(/** @lends BookmarksRouter.prototype */{

	routes: {
		'bookmarks(/:id)(/)': 'view',
		'bookmarks/:id/edit(/)': 'edit',
		'bookmarks/:id/new-folder(/)': 'createFolder'
	},

	Nav: BookmarksNav,
	Model: Bookmark,
	section: 'bookmarks',

	view: function(id) {
		// before display since we're fiddling with what's being spectated.
		// note it wouldn't make sense for briefings to do this, because
		// you can have a bookmark of a briefing, but not the other way around
		spectator.setCurrent(null)
		let options = { id }
		if (_.isNil(id)) {
			options.autoSelectRoot = true
		}
		this.nav(options).then(nav => {
			const bookmarkOptions = () => {
				// Timelines requires that initiative calculations be fetched for the entire org
				// If other routes require domainOrgId too maybe this should be factored out somewhere else
				const modelUrl = _.get(_.invoke(nav, 'gardener.tree.get', id), 'url', '')
				const domainOrgId = !!modelUrl.match(/initiatives\/\d*\/timeline/)
				return {domainOrgId}
			}

			if (id) {
				appDisplay.display(this.load(id, bookmarkOptions()), (model, response, options) => {

					// If a bookmark resource requires the org to be set it will be returned in the header
					// For example, initiative timelines (#18029)
					const orgId = nav.gardener.getOrgId(options.xhr)
					orgId && (globals.orgId = orgId)

					if (model.get('type') == 'folder') {
						return new BookmarksFolderOverview({
							model: model,
							tabs: ViewEditTabs,
							tabsContext: {
								hideInfo: true,
								hideAlerts: true
							},
							overviewTabCode: 'common.view',
							// fixes 9513 we don't want the Bookmark and Send To
							// buttons.  Must be a space and not an empty string
							displayHeaderButtons: ' '
						})
					} else {
						return new BookmarksOverview({ model: model })
					}
				})
			} else {
				//#33354 #33273 #32756 #31937 in non bookmark sections, when initially
				//switching to that section, the url uses an organization url and
				//app-router handles loading the overview for that section, but in
				//bookmarks this code block is executed instead (it does not have an
				//organization endpoint) in this case, because we're auto selecting
				//the root when there is no id in the url, we'll need to get that
				//id of the root node once the tree has been rendered
				this.listenToOnce(nav.gardener, 'tree:rendered', () => {
					nav.onSelect(nav.gardener.tree.selected())
				})
			}
		})
	},

	edit: function(id) {
		const modelPromise = this.load(id, {domainOrgId: true})
		appDisplay.display(modelPromise, function(model, resp, options) {
			if (model.get('type') === 'folder') {
				return new BookmarksFolderForm({
					model: model,
					tabs: ViewEditTabs,
					overviewTabCode: 'common.view'
				})
			} else {
				return new BookmarksEdit({model: model})
			}
		})
		this.navForModel({ id, edit: true }, modelPromise)
	},

	createFolder: function(relativeId, orgId) {
		orgId = orgId || globals.orgId
		var bookmark = new Bookmark({
			relativeId: relativeId,
			organizationId: orgId,
			type: 'folder',
			// the icon must be specified or else no icon is visible after
			// adding a new folder b/c the bookmarks gardener keys off the icon
			// property not the type property
			icon: 'folder'
		})
		const form = new BookmarksFolderForm({
			model: bookmark,
			tabs: ViewEditTabs,
			overviewTabCode: 'common.view'
		})
		this.navForNewModel({ relativeId, orgId, form, model: bookmark})
	}

})

export default BookmarksRouter

BookmarksRouter.__filename__ = 'bookmarks/bookmarks-router.js'
